import React, { useEffect, useRef, useState } from 'react'
import QRCode from 'react-qr-code';
import * as htmlToImage from "html-to-image";
import { useNavigate, useParams } from 'react-router-dom';


import axios from "../axiosInstance";
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import { errorMessage } from '../hooks/UserLogs';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ConfirmModal from '../components/confirmModal';
export default function AgentDetails() {
  const [agent, setAgent] = useState({});
  const [profile, setProfile] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowError] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [idUser, setIdUser] = useState('');
  const qrCodeRef = useRef(null);
  const inputFile = useRef(null);
  const { id } = useParams();

  const bUrl = process.env.REACT_APP_B_URL;
  const [showModalConfirmActive, setShowModalConfirmActive] = useState(false);
  const [showModalConfirmBlocked, setShowModalConfirmBlocked] = useState(false);

  const handleShowConfirmActive = (id, isActive) => {
      setShowModalConfirmActive(true);
      setIdUser(id);
      setIsActive(isActive);
  }
  const handleShowConfirmBlocked = (id, isBlocked) => {
    setShowModalConfirmBlocked(true);
    setIdUser(id);
    setIsBlocked(isBlocked);
}

const handleCloseConfirmActive = () => setShowModalConfirmActive(false);
const handleCloseConfirmBlocked = () => setShowModalConfirmBlocked(false);

  const navigate = useNavigate();

  const activeOrDeactiveCustomer = async () => {

      const response = await axios.post(bUrl + "/customerWallet/activeOrDesactive", {
        "fkIdStaff": sessionStorage.getItem("idUser"),
        "idUser": idUser
      }).catch((err) => {
        console.log(err);
        setIsLoading(false)

      });
      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          seterrMsg(msg);
          setShowError(true);
        }else{
          getAgent()
        }
        
        setIsLoading(false);
      }
    
  }
  const blokeOrDeblokeCustomer = async () => {

      const response = await axios.post(bUrl + "/customerWallet/blockeOrDebloke", {
        "fkIdStaff": sessionStorage.getItem("idUser"),
        "idUser": idUser
      }).catch((err) => {
        console.log(err);
        setIsLoading(false)

      });
      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          seterrMsg(msg);
          setShowError(true);
        }else{
          getAgent()
        }
        setIsLoading(false);
      }
    
  }
  const getAgent = async () => {
    const response = await axios.get(bUrl + "/agent/findById/" + id).catch((err) => {
      console.log(err);
      setIsLoading(false)

    });
    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowError(true);
      }else{
        setAgent(response.data.body);
      }
      
      setIsLoading(false);
    }
  }
  
  const handleCloseError = () => {
    setShowError(false);
  }
  const handleFileChange = (e) => {
    if (e.target.files) {
      setProfile(e.target.files[0]);
      const formData = new FormData();
      formData.append('formFile', e.target.files[0], id + '.jpg');
      axios.post(bUrl + '/UploadFile', formData).then((res) => {
        console.log(res);
        //setView(false);
        setTimeout(() => {
          //viewShow(idEmp)
        }, 1000)



      }).catch((err) => {
        console.log(err);
      })
    }
  };

  const downloadQRCode = () => {
    htmlToImage.toPng(qrCodeRef.current).then(function (dataUrl) {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "qr-code.png";
      link.click();
    })
      .catch(function (error) {
        console.error("Error generating QR code:", error);
      });
  };
  useEffect(() => {
    if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
    getAgent();
  }, []);
  return (
    <div>
      <Sidebar />
      <section className="home ">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
              <div><p className='fw-bold'>Marchand &gt; Détails</p></div>
              <div><Topbar /></div>
            </div>

            {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
              <div className="table-content mt-3 p-3">
                <div className='row d-flex justify-content-center'>
                  {/* <div className='col-md-3'><input type="file" multiple ref={inputFile} hidden onChange={(e)=>handleFileChange(e)}/>
            <img src={agent.name} alt='img' className='w-100 im-upload' /></div> */}

                  {/* <button className='btn' onClick={} >Changer</button> */}
                  {agent?
                  <div className='col-md-6'>
                    <hr />
                    <div className='row mb-2 p-2'>
                      <div className='col-3'>Name:</div>
                      <div className='col-9 fw-bold'>{agent.firstName + " " + agent.middleName + " " + agent.lastName}</div>
                    </div>
                    <hr />
                    <div className='row mb-2 p-2'>
                      <div className='col-3'>Email:</div>
                      <div className='col-9 fw-bold'>{agent.email}</div>
                    </div>
                    <hr />
                    <div className='row mb-2'>
                      <div className='col-3'>Gender:</div>
                      <div className='col-9 fw-bold'>{agent.sexe}</div>
                    </div>
                    <hr />

                    <div className='row mb-2'>
                      <div className='col-3'>Phone:</div>
                      <div className='col-9 fw-bold'>{agent.phone}
                      </div>
                    </div>
                    <hr />

                    <div className='row mb-2'>
                      <div className='col-3'>Bloque:</div>
                      <div className='col-9 fw-bold'>
                        <label className="switch">
                          <input type="checkbox" className="i-btn" checked={agent.isBlocked ? 'checked' : ''} onChange={(e) => blokeOrDeblokeCustomer(agent.idCustomerWallet, e.target.checked)} />
                          <span className="slider-btn round"></span>
                        </label>
                      </div>
                    </div>
                    <hr />

                    <div className='row mb-2'>
                      <div className='col-3'>Active:</div>
                      <div className='col-9 fw-bold'>
                        <label className="switch">
                          <input type="checkbox" className="i-btn" checked={agent.isActive ? 'checked' : ''} onChange={(e) => activeOrDeactiveCustomer(agent.idCustomerWallet, e.target.checked)} />
                          <span className="slider-btn round"></span>
                        </label>
                      </div>
                    </div>
                    <hr />

                  </div>
                  :<> </>}
                  <Modal show={showError} onHide={handleCloseError} className="">
                    <Modal.Header closeButton className="bg-danger">
                      <Modal.Title>ERROR</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleCloseError}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <ConfirmModal
                      show={showModalConfirmActive}
                      handleClose={handleCloseConfirmActive}
                      handleConfirm={activeOrDeactiveCustomer}
                  />
                  
                  <ConfirmModal
                      show={showModalConfirmBlocked}
                      handleClose={handleCloseConfirmBlocked}
                      handleConfirm={blokeOrDeblokeCustomer}
                  />
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    </div>
  )
}
